import React from 'react';
import user from "../assets/imgs/user.jpeg";

const LiveSupportCArd = () => {
  return (
    <div className='lg:w-[412px] md:w-full sm:w-full w-full h-[370px] bg-white rounded-md py-8 px-6'>
        <div className='flex justify-between items-center pb-2'>
            <h2 className='heading-two'>Live Support Request:</h2>
            <p className='text-regular text-secondary-n-70'>view more</p>
        </div>

      <div className='flex flex-col gap-2'>
      <div className='flex justify-between items-center'>
          <div className='flex items-center gap-3'>
            {/* <div className='rounded-full w-10 h-10 bg-slate-800'></div> */}
            <div className='w-11 h-11 '>
            <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
            <p className='text-regular'>Ronald Richards</p>
          </div>
          <p className='flex justify-center items-center bg-primary-yellow-500 text-white text-regular w-[120px] h-6 rounded-xl px-3 py-3'>Support Now</p>
        </div>
        <div className='flex justify-between items-center'>
          <div className='flex items-center gap-3'>
            {/* <div className='rounded-full w-10 h-10 bg-slate-800'></div> */}
            <div className='w-11 h-11 '>
            <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
            <p className='text-regular'>Ronald Richards</p>
          </div>
          <p className='flex justify-center items-center bg-primary-yellow-500 text-white text-regular w-[120px] h-6 rounded-xl px-3 py-3'>Support Now</p>
        </div>
        <div className='flex justify-between items-center'>
          <div className='flex items-center gap-3'>
            {/* <div className='rounded-full w-10 h-10 bg-slate-800'></div> */}
            <div className='w-11 h-11 '>
            <img src={user} alt="user" height={100} width={100} className="rounded-full !w-full !h-full" />
            </div>
            <p className='text-regular'>Ronald Richards</p>
          </div>
          <p className='flex justify-center items-center bg-primary-yellow-500 text-white text-regular w-[120px] h-6 rounded-xl px-3 py-3'>Support Now</p>
        </div>
      </div>
    </div>
  )
}

export default LiveSupportCArd